export default {
  title: 'CANCELLATION FEES',
  items: {
    RideCreditOffer: {
      label: 'Feature Toggle for Ride Credit Offer',
      type: 'boolean'
    },
    RefundDelayMins: {
      label: 'Refund Delay in Minutes',
      type: 'integer',
      unit: 'minutes',
      extra: '(To disable refund delays, set this value to 0)'
    },
    NumberFreeChances: {
      label: 'Number of Free Chances',
      type: 'integer',
      unit: 'chances (0-99)'
    },
    CancellationFee: {
      label: 'Cancellation Fee',
      type: 'integer',
      unit: 'fee'
    },
    CancelationFeeCurrency: {
      label: 'Cancellation Fee Currency',
      type: 'dropdown',
      values: ['$', '%']
    },
    ResetFrequency: {
      label: 'Reset Frequency',
      type: 'integer',
      unit: 'days (0-999)'
    },
    ChargeCancelationHours: {
      label: 'RSVP Cancellation',
      type: 'integer',
      unit: 'hours from pickup time'
    },
    CancellationFeeHours: {
      label: 'Late Cancel Fee',
      type: 'integer',
      unit: 'fee'
    },
    CancellationFeeHoursCurrency: {
      label: 'Late Cancel Fee Currency',
      type: 'dropdown',
      values: ['$', '%']
    },
    ChainNoShowFee: {
      label: 'Shared No Show Fee',
      type: 'integer',
      unit: '$ ($0 - $99.99)'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/cancellation-fees.js